import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useNotifications, useReadNotifications } from '@/api/queries/replies';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { timeAgo } from '@/lib/format';

/** The bell (Step 11): new replies (2026-10-27) and other notices for me; opening one marks it read. */
export function NotificationBell() {
  const data = useNotifications().data;
  const read = useReadNotifications();
  const navigate = useNavigate();
  const unread = data?.unread ?? 0;
  const list = data?.notifications ?? [];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label={unread > 0 ? `Notifications, ${unread} unread` : 'Notifications'}
          className="relative"
        >
          <Bell aria-hidden="true" />
          {unread > 0 && (
            <span className="absolute -top-0.5 -right-0.5 grid min-w-4 place-items-center rounded-full bg-primary px-1 text-[10px] font-semibold text-primary-foreground">
              {unread > 9 ? '9+' : unread}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80">
        <DropdownMenuLabel className="flex items-center justify-between">
          Notifications
          {unread > 0 && (
            <button
              type="button"
              className="text-xs font-normal text-primary hover:underline"
              onClick={() => read.mutate(undefined)}
            >
              Mark all read
            </button>
          )}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {list.length === 0 && (
          <p className="px-2 py-4 text-center text-sm text-muted-foreground">Nothing new.</p>
        )}
        {list.slice(0, 10).map((n) => (
          <DropdownMenuItem
            key={n.id}
            className="grid items-start gap-0.5"
            onSelect={() => {
              if (!n.read) read.mutate([n.id]);
              if (n.link) void navigate(n.link);
            }}
          >
            <span className={n.read ? 'text-muted-foreground' : 'font-medium'}>{n.title}</span>
            {n.body && <span className="line-clamp-2 text-xs text-muted-foreground">{n.body}</span>}
            <span className="text-xs text-muted-foreground">{timeAgo(n.createdAt)}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
